import React from "react";
import styled from "@emotion/styled";

const Head = styled.h2`
  color: #000;
  text-align: center;
  font-weight: 700;
  margin-top: 5%;
`;
const Head2 = styled.h3`
  color: #000000;
  text-align: center;
  font-weight: 700;
`;
const Head3 = styled.h4`
  color: #000000;
  font-weight: 700;
`;
const COntenido = styled.div`
  color: #000000;
  text-align: justify;
  margin-left: 12%;
  margin-right: 12%;
`;

const OL = styled.ol`
  counter-reset: item;
`;

const LI = styled.li`
  display: block;
  ::before {
    content: counters(item, ".") " ";
    counter-increment: item;
  }
`;

const Politicas = () => {
  return (
    <COntenido>
      <Head>
        TÉRMINOS Y CONDICIONES GENERALES PARA EL USO DE LA PLATAFORMA
        “RAPIDFAST”
      </Head>
      <Head2>
        DISPOSICIONES APLICABLES PARA EL CONTROL Y MITIGACIÓN DEL COVID-19
      </Head2>

      <p>
        {" "}
        Los Usuarios declara que durante la vigencia de la crisis por Covid-19:
      </p>
      <p>
        Se asegurará de que las solicitudes y el uso de los servicios prestados
        por la plataforma se utilizarán exclusivamente para la ejecución de
        aquellas actividades que estén expresamente exentas por las leyes
        dictadas por las autoridades nacionales y locales, y que estas
        actividades se ejecutarán adecuadamente.
      </p>
      <p>
        En este sentido, los usuarios que soliciten servicios serán los únicos
        responsables de demostrar a las autoridades competentes si han sido
        autorizados o cubiertos por alguna excepción a las restricciones de
        circulación.
      </p>
      <p>
        Durante la ejecución del servicio, siempre utilizarán correctamente los
        elementos de protección personal requeridos por las autoridades
        sanitarias, por lo que, en todo momento, los usuarios que soliciten el
        servicio deberán portar al menos sus respectivas mascarillas. Cuando
        descubra que tiene síntomas de alarma como fiebre, tos o dificultad para
        respirar, no solicitará ningún servicio
      </p>
      <p>
        Durante la ejecución del servicio, el usuario que solicita el servicio y
        el usuario prestador que acepta el servicio deben mantener las ventanas
        abiertas y tomar las medidas necesarias para facilitar la circulación
        del aire en el interior.
      </p>

      <p>
        Suministrará información veraz sobre su estado de salud a través de los
        canales de notificación y acompañamiento dispuestos por las autoridades
        de salud y por Rapidfast; Notificará a su EPS cuando tenga síntomas
        tales como fiebre, tos o dificultad respiratoria.
      </p>
      <p>
        La solicitud y ejecución de los Servicios, en todo caso, se efectúa bajo
        su voluntad, autonomía y responsabilidad, eximiendo a Rapidfast respecto
        de cualquier reclamación.
      </p>
      <p>
        Cuando el Usuario Solicitante del Servicio se da cuenta de que el
        Usuario Prestador del Servicio no ha adoptado las medidas y protocolos
        de bioseguridad personal adoptados por las autoridades sanitarias para
        controlar y mitigar al Covid-19, deberá evitar recibir cualquier
        servicio. Asimismo, cuando el Usuario Solicitante del Servicio no cumpla
        con las medidas y acuerdos anteriores, el Usuario Prestador del Servicio
        deberá evitar iniciar cualquier servicio, así mismo Usuario Solicitante
        del Servicio entiende y acepta que el Usuario Prestador del servicio se
        abstendrá de transportar más de dos (2) Usuarios Solicitantes durante la
        ejecución de un mismo servicio.
      </p>
      <p>
        La solicitud y ejecución de los Servicios, en todo caso, se efectúa bajo
        su voluntad, autonomía y responsabilidad, eximiendo a Rapidfast respecto
        de cualquier reclamación.
      </p>

      <Head2>
        POLITICAS DE USO DE LA PLATAFORMA, REQUISITOS TÉCNICOS Y RESTRICCIONES
        DE USO:
      </Head2>
      <OL>
        <Head3>GENERALIDADES</Head3>
        {/* I1 */}
        <LI>
          <b>Compañia</b> <br />
        </LI>
        <p>
          RAPID FAST S.A.S. es una sociedad constituida conforme a las leyes de
          Colombia, domiciliada en la ciudad Bogotá D.C., representada legal
          mente por JUAN DANIEL SUAREZ mayor de edad con CC 1.077.870.326, para
          los efectos de Términos y Condiciones en adelante se denominará
          Proveedores.
        </p>
        {/* F1*/}
        {/* I2 */}
        <LI>
          <b>Definiciones</b>
          <br />
          <OL>
            <LI>
              <b>Servicios:</b>
              prestados por los Aliados y puestos a disposición de los Usuarios
              a través de Plataformas App y Web de los Proveedores. b) alquiler
              de plataformas App a aliados con la finalidad de encontrar
              usuarios que requieran el servicio de transporte.
            </LI>
            <br />
            <LI>
              <b>Aliado:</b>cualquier persona natural que, cumpliendo con los
              requisitos de vinculación y adhiriéndose a los términos y
              condiciones fijados por los Proveedores, decida voluntariamente
              prestar los Servicios.
            </LI>
            <br />
            <LI>
              <b>Usuario:</b> cualquier persona que voluntariamente decida
              contratar los Servicios ofrecidos por los Aliados en las
              plataformas de los Proveedores y que se adhiera a los Términos y
              Condiciones dispuestos por el mismo.
            </LI>
            <br />
            <LI>
              <b>Plataforma:</b> programa virtual (software) App y/o Web
              mediante la cual los Proveedores ponen a disposición del Usuario
              los Servicios de los Aliados.
            </LI>
            <br />
            <LI>
              <b>Proveedor:</b> RAPID FAST S.A.S. es una sociedad constituida
              conforme a las leyes de Colombia, encargada de ofrecer los
              Servicios de los aliados y de fijar los términos y condiciones de
              uso dirigidos a los Usuarios y a los Aliados.
            </LI>
            <br />
            <LI>
              <b>Novedad:</b> cualquier solicitud o reclamación por parte del
              Usuario y/o Aliado referente a: (i) pérdidas, (ii) daños totales o
              parciales de los productos en relación con un Servicio solicitado
              a través de la Plataforma, y/o (iii) la ejecución de los
              Servicios.
            </LI>
            <br />
            <LI>
              <b>Cookies:</b> son pequeños archivos que se instalan en el disco
              duro de la terminal con la que acceda el Usuario, para la consulta
              por parte de los Proveedores acerca de la actividad, hábitos y
              preferencias de consumo de los Usuarios.
            </LI>
            <br />
            <LI>
              <b>Datos Personales:</b> cualquier pieza de información vinculada
              o qué pueda asociarse a una o varias personas naturales,
              determinadas o determinables.
            </LI>
            <br />
            <LI>
              <b>Propiedad Intelectual:</b> cualquier activo intangible
              susceptible de protección por vía de Propiedad Intelectual,
              incluyendo, pero sin limitarse a, signos distintivos, nuevas
              creaciones, secretos empresariales y todas las obras y contenidos
              amparados por el derecho de autor.
            </LI>
            <br />
          </OL>
        </LI>
        {/* F2 */}
        {/* I3*/}
        <LI>
          <b>Objeto</b>
          <p>
            El presente documento fija los Términos y Condiciones en los que los
            Usuarios y los Aliados podrán acceder a la Plataforma para coordinar
            utilizar e interactuar entre sí en relación con los Servicios que
            prestan los Aliados.
          </p>
          <p>
            Establece los Términos y Condiciones entre Proveedor y Aliado sobre
            el alquiler y uso de la App y/o plataforma
          </p>
          <p>
            El ingreso y uso de la Plataforma o App por parte del Aliado y/o del
            Usuario es una declaración formal e inequívoca sobre la aceptación a
            todos los términos y condiciones incluidos en el presente documento.
          </p>
          <p>
            El Proveedor se reserva el derecho a modificar los Términos y
            Condiciones del presente documento sin previo aviso a los Aliados
            y/o Usuarios. Dichas modificaciones surtirán efecto a partir de su
            publicación en la Plataforma. Igualmente, los Proveedores se
            reservan el derecho a realizar pruebas de diferentes productos,
            comunicaciones y tarifas sin previo aviso, con la idea de recabar
            información que ayude a mejorar la App y/o plataforma.
          </p>
        </LI>
        {/* F3 */}
        {/* I4 */}
        <LI>
          <b>Responsabilidad</b>
        </LI>

        <p>
          El Proveedor, en su calidad de intermediario, no es responsable por la
          eficiencia, efectividad, eficacia y calidad de los servicios prestados
          por los Aliados, en la medida en que estos (i) no son prestados por el
          Proveedor, (ii) los Usuarios no están bajo una relación de
          subordinación con el Proveedor y (iii) los servicios ofrecidos por el
          Proveedor se limita a la habilitación de la Plataforma para facilitar
          la comunicación entre los Usuarios y los Aliados. En consecuencia, el
          Proveedor no se hace responsable por ningún acontecimiento o
          inconveniente que se presente en la ejecución de los Servicios. Sin
          perjuicio de lo anterior.
        </p>
        {/* F4 */}
        {/* I5 */}
        <LI>
          <b>Propósito del uso de los Servicios</b>
          <p>
            El Aliado y/o Usuario se obliga a sólo utilizar la Plataforma con
            los propósitos y fines permitidos por la ley. Por lo tanto, el
            Aliado no atenderá y el Usuario no solicitará ningún Servicio a
            través de la Plataforma para causar incomodidad o inconveniencia a
            otros. Está prohibido utilizar la Plataforma para impedir,
            obstaculizar o bloquear el correcto funcionamiento del sistema del
            Proveedor RAPID FAST.
          </p>
          <p>
            El Usuario no utilizará la Plataforma con el propósito de solicitar
            el transporte de elementos prohibidos, aquellos objetos cuya
            circulación no se permita por motivos de seguridad, sanidad pública,
            utilidad general y/o legalidad. El Usuario deberá declarar la
            naturaleza real del producto objeto del Servicio, con el fin de
            evitar cualquier tipo de vicio en la prestación del servicio.
          </p>
          <p>
            El Aliado y/o Usuario deberá mantener indemne e indemnizar a los
            Proveedores por cualquier pérdida, daño, investigación, demanda,
            reclamación, litigio, o cualquier proceso judicial o extrajudicial
            en el que se vean involucrados los Proveedores por la violación por
            parte del Aliado y/o Usuario de la presente cláusula.
          </p>
        </LI>
        {/* F5 */}
        {/* I6 */}
        <LI>
          <b>Propiedad Intelectual</b>
          <p>
            La Propiedad Intelectual de la Plataforma y su funcionamiento para
            lograr la prestación de los Servicios a través de esta es de
            propiedad exclusiva del Proveedor RAPID FAST S.A.S. Esto incluye la
            totalidad del software, sus partes, así como cualquier signo
            distintivo, incluyendo pero sin limitarse a las marcas, el nombre,
            el logo, y/o alguno de sus componentes.
          </p>
          <p>
            Está prohibida la copia y/o distribución total o parcial del
            software que es de titularidad del Proveedor RAPID FAST S.A.S.,
            incluso si el fin de dicha copia es una actividad sin lucro
            económico. El software del Proveedor RAPID FAST S.A.S. es para uso
            propio y, en consecuencia, es intransferible a cualquier título y
            bajo cualquier modalidad. Es obligación del Aliado mantener su
            nombre de usuario y su contraseña secreta y deberá responder por el
            mal uso que cualquier tercero le pueda dar a la Plataforma.
          </p>
        </LI>
        {/* F6 */}
        {/* I7 */}
        <LI>
          <b>Uso de la Información</b>
          <p>
            Los Proveedores se reservan el derecho al uso de la información
            recolectada en el registro a la Plataforma y la información generada
            o derivada del uso de la Plataforma. La información de registro se
            usa esencialmente para facilitar la comunicación y el contacto entre
            el Aliado y el Usuario. Situación que está aprobada tanto por Aliado
            como por Usuario.
          </p>
        </LI>
        {/* F7 */}
        {/* I8 */}
        <LI>
          <b>Peso, dimensiones y precauciones</b>
          <p>
            Para los Servicios de domicilios y mensajería, los productos del
            Usuario no podrán superar los cincuenta (50) cm de alto, largo y
            ancho. Así mismo el peso del producto no podrá exceder cincuenta
            (50) kg. Para los servicios de transporte de carga y/o acarreos, las
            dimensiones y pesos se acordarán directamente con los Aliados,
            dependiendo del vehículo que tengan disponible para la operación.
          </p>
          <p>
            Adicionalmente el Usuario debe garantizar que la mercancía de su
            Servicio esté empacada de manera óptima de tal forma que no sea
            susceptible a daños en un recorrido normal en bicicleta, moto, carro
            o cualquier otro vehículo idóneo. El Aliado se abstendrá de recibir
            la mercancía que no cumpla con las condiciones previstas en esta
            sección.
          </p>
        </LI>
        {/* F8 */}
        {/* I9 */}
        <LI>
          <b>Política de revisión del valor de servicios y modificaciones</b>
          <p>
            Los Aliados y/o Usuarios tendrán un periodo de hasta treinta (30)
            días calendario a partir de la solicitud de un Servicio para
            presentar a los Proveedores cualquier Novedad.
          </p>
          <p>
            En caso de que ante alguna Novedad no haya sido posible contactar al
            Aliado y/o Usuario que solicitó el Servicio, los Proveedores
            enviarán por correo electrónico al correo registrado del Aliado y/o
            Usuario la información pertinente sobre la Novedad. El Aliado y/o
            Usuario tendrá dos (2) días hábiles para responder frente a dicha
            Novedad. En caso de no recibir respuesta en ese término, se
            entenderá que se aceptó la Novedad y que el Aliado /o Usuario
            desiste de cualquier reclamación posterior.
          </p>
        </LI>
        {/* F9 */}
        {/* I10 */}
        <LI>
          <b>No garantías adicionales</b>
          <p>
            El Aliado y/o Usuario acepta que los Proveedores no dan ninguna
            declaración y/o garantía, expresa, implícita o estatutaria, que no
            esté expresamente establecida en estos Términos y Condiciones. El
            Aliado y/o Usuario acepta que todo riesgo derivado del uso de la
            Plataforma y de los Servicios será únicamente suyo, de conformidad
            con los Términos y Condiciones.
          </p>
        </LI>
        {/* F10 */}
        {/* I11 */}
        <LI>
          <b>Limitación de responsabilidad.</b>
          <p>
            Los Proveedores no serán responsables de daños indirectos,
            incidentales, especiales, ejemplares, punitivos o emergentes,
            incluidos el lucro cesante, la pérdida de datos, la lesión personal
            o el daño a la propiedad, ni de perjuicios relativos, o en relación
            con, o de otro modo derivados de cualquier uso de los Servicios.
            Esto incluye daños derivados de (i) el uso de la Plataforma, o (ii)
            cualquier Servicio en manos de un Aliado. Los Proveedores en ningún
            caso serán responsables por cualquier pérdida o daño en un monto que
            exceda el valor del Servicio indicado por la Plataforma.
          </p>
        </LI>
        {/* F11 */}
        {/* I12 */}
        <LI>
          <b>Tratamiento de Datos Personales.</b>
          <p>
            Por medio de la vinculación a la Plataforma, el Aliado y/o Usuario
            autoriza a los Proveedores el tratamiento de sus datos personales, y
            que dichos datos sean incorporados en las bases de datos de los
            Proveedores y almacenadas en servidores de los Proveedores. El
            tratamiento que se le dará a los datos personales incluye la
            recolección, almacenamiento, uso y circulación al interior de la
            empresa, o de sus afiliadas, y se realizará en conformidad con las
            Políticas de Tratamiento de Datos Personales de los Proveedor
            (disponibles en las páginas web de los Proveedores), la Ley
            Estatutaria 1581 de 2012, el Decreto 1377 de 2013 y el Decreto 886
            de 2014.
          </p>
        </LI>
        {/* F12 */}
        {/* I13 */}
        <LI>
          <b>Uso de Cookies.</b>
          <p>
            La Plataforma del Proveedor RAPID FAST S.A.S., utiliza cookies
            propias y de terceros con la finalidad de: (i) optimizar los
            servicios ofrecidos, (ii) ofrecer una mejor experiencia de
            navegación al Aliado y/o Usuario, y (iii) brindarle información de
            todo tipo al Aliado y/o Usuario conforme con sus preferencias.
          </p>
          <p>
            Estas cookies pueden ser de varios tipos: 1) Por su duración: (i)
            cookie de sesión, esto es, aquellas que únicamente permanecen
            activas mientras el Aliado y/o Usuario registrado haga uso de un
            determinado espacio web, permitiendo identificar al Aliado y/o
            Usuario con el fin de personalizar su experiencia. Finalizada la
            sesión, esta cookie desaparecerá sin que sean almacenadas en el
            disco duro del dispositivo, (ii) cookie permanente, esto es, aquella
            programada directamente por la Plataforma con el fin de realizar el
            seguimiento al Aliado y/o Usuario cada vez que se genera una nueva
            visita. 2) Por su finalidad: (i) cookies esenciales o técnicas, esto
            es, aquellas indispensables para garantizar la adecuada navegación,
            permitiendo el correcto tráfico y reconocimiento de datos, (ii)
            cookies de personalización, aquellas que almacenan las preferencias
            de cierto dispositivo como por ejemplo, el idioma, el tipo de
            navegador, las características que tiene el portal dependiendo el
            lugar del mundo desde el que se acceda a él, etc., (iii) cookies de
            análisis, aquellas que permiten la creación de un perfil de
            navegación por Aliado y/o Usuario, analizando el comportamiento de
            este y sus preferencias, y (iv) cookies publicitarias, esto es,
            aquellas usadas para campañas de marketing propias o de terceros,
            destinadas a dar a conocer al Aliado y/o Usuario productos y/o
            servicios en espacios previamente definidos por los Proveedores para
            el efecto. Estas cookies pueden ser de tipo comportamental, es
            decir, que se diseñan para almacenar información sobre las visitas
            frecuentes del Aliado y/o Usuario y la observación continuada de sus
            hábitos de navegación, esto a su vez, permite crear un perfil para
            mostrar publicidad de acuerdo con el análisis realizado.
          </p>
          <p>
            Por lo tanto, el Aliado y/o Usuario acepta que la Plataforma utilice
            “cookies” para recolectar información sobre su interacción en la
            Plataforma. En todo caso, el Aliado y/o Usuario puede escoger
            visitar la Plataforma del Proveedor RAPID FAST S.A.S., sin
            “cookies”, para lo cual puede configurar su navegador para que
            rechace todas las “cookies”, o para que le avise cuando se cree una
            “cookie”. (Cada navegador es diferente, de modo que deberá consultar
            el menú «Ayuda» del suyo para saber cómo modificar sus preferencias
            con relación a las “cookies”.). Sin perjuicio de lo anterior, en
            caso de cancelar el uso de Cookies para el navegador, el Aliado y/o
            Usuario acepta que no podrá beneficiarse de muchas de las funciones
            de la Plataforma, y acepta que el uso de la Plataforma puede verse
            impactado.
          </p>
        </LI>
        {/* F13 */}
        {/* I14 */}
        <LI>
          <b>Autorización de Consulta y Reportes.</b>
          <p>
            El Usuario y/o Aliado declara que la información que ha suministrado
            en la Plataforma y durante la relación comercial es verídica y da su
            consentimiento expreso e irrevocable a los Proveedores para:
          </p>
          <OL>
            <LI>
              Consultar, en cualquier tiempo, en cualquier central del riesgos o
              base de datos, tales como central de información de entidades
              financieras de Colombia o DataCrédito o en cualquier otro operador
              de información financiera y crediticia, toda la información
              relevante para adelantar estudios de riesgo crediticio en
              cualquiera de sus etapas y para la realización de campañas de
              mercadeo y ofrecimiento de productos.
            </LI>
            <br />
            <LI>
              Reportar a cualquier central de riesgos o base de datos, tales
              como central de información de entidades financieras de Colombia o
              DataCrédito o a cualquier central de información de riesgo, datos
              sobre el cumplimiento o incumplimiento de sus obligaciones
              crediticias, comerciales o de servicios o de sus deberes legales
              de contenido patrimonial, y sus datos de ubicación y contacto,
              conforme a los límites dispuestos en la Ley 1266 de 2008.
            </LI>
            <br />
            <LI>
              Suministrar a cualquier central del riesgos o base de datos, tales
              como central de información de entidades financieras de Colombia o
              DataCrédito o a cualquier otra central de información de riesgo
              datos relativos a sus solicitudes de crédito, así como otros
              atinentes a sus relaciones comerciales, financieras y en general
              socioeconómicas que el Usuario haya entregado o que consten en
              registros públicos, bases de datos públicas o documentos públicos.
            </LI>
            <br />
            <LI>
              Suministrar a cualquier central del riesgos o base de datos, tales
              como central de información de entidades financieras de Colombia o
              DataCrédito o a cualquier otra central de información de riesgo
              datos relativos a sus solicitudes de crédito, así como otros
              atinentes a sus relaciones comerciales, financieras y en general
              socioeconómicas que el Usuario haya entregado o que consten en
              registros públicos, bases de datos públicas o documentos públicos.
            </LI>
          </OL>
        </LI>
        <br />
        {/* F14 */}
        {/* I15 */}
        <LI>
          <b>Ley aplicable y Solución de Controversias.</b>
          <p>
            Estos Términos y Condiciones son regidos enteramente por la Ley
            Colombiana. Cualquier diferencia o controversia que surja entre las
            partes relativas a este contrato, a su ejecución, cumplimiento y/o
            liquidación, se tratará de arreglar directa y amigablemente entre
            las partes. Si después de transcurridos quince (15) días calendario
            de la notificación escrita de la controversia de una de las partes a
            la otra, sin que se llegare a un acuerdo negociado, ésta será
            decidida por la jurisdicción ordinaria.
          </p>
        </LI>
        {/* F15 */}
        {/* I16 */}
        <LI>
          <b>Aceptación.</b>
          <p>
            El Aliado y/o Usuario declara y garantiza (i) que tiene capacidad
            legal para usar la Plataforma y para contratar con los Proveedores,
            (ii) que ha leído la totalidad de los Términos y Condiciones, (iii)
            que acepta los Términos y Condiciones en su totalidad y se obliga a
            cumplirlos.
          </p>
        </LI>
        {/* F16 */}
        <Head3>DISPOSICIONES ESPECIALES PARA ALIADOS</Head3>
        {/* I17 */}
        <LI>
          <b>Definición y alcance del servicio prestado.</b>
        </LI>
        <p>
          Por medio de la Plataforma, los Proveedores permiten al Aliado el
          acceso a la Plataforma, para facilitar que el Aliado preste sus
          servicios de mensajería, domicilios y/o transporte a los Usuarios. Una
          vez el Usuario elija un Servicio, alguno de los Proveedores pondrá en
          contacto al Usuario con el Aliado para que este, por su propia cuenta
          y riesgo, realice las actividades propias del servicio de entrega. En
          esta medida, los Proveedores actúan únicamente como un intermediarios
          que facilitan el contacto entre el Usuario y el Aliado a travez del
          alquiler de la App.
        </p>
        <p>
          Los Servicios estarán disponibles en Bogotá D.C. Los Proveedores
          podrán, bajo su propio criterio, ampliar la cobertura de los Servicios
          a otras ciudades.
        </p>
        {/* F17 */}
        {/* I18 */}
        <LI>
          <b>Tarifas.</b>
          <p>
            Como contraprestación por los Servicios prestados, el Usuario deberá
            pagar al Aliado una tarifa que se especificará al momento de
            solicitar cada Servicio. Por lo tanto, el Aliado otorga un mandato
            para que los Proveedores, en nombre y por cuenta del Aliado,
            recolecten y posteriormente distribuyan el valor que corresponda de
            acuerdo con el volumen de Servicios solicitados por los Usuarios y
            efectivamente prestados por el Aliado.
          </p>
          <p>
            La distribución de los recursos recolectados por los Proveedores por
            cuenta y en nombre del Aliado será hecha, el segundo y/o cuarto
            martes de cada mes – una vez haya sido solicitada por el Aliado – a
            través de la aplicación “Daviplata”, de propiedad de Banco
            Davivienda S.A. o NEQUI de propiedad de Bancolombia, a la cuenta que
            designe el Aliado. El valor de la transferencia se especificará al
            momento de la solicitud de los Servicios.
          </p>
          <p>
            Los Proveedores se podrán abstener de realizar cualquier
            distribución de la tarifa a favor del Aliado en caso de que éste no
            suministre prueba, a satisfacción de los Proveedores, de los
            comprobantes de pago de las cotizaciones al sistema general de
            seguridad social. Igualmente, los Proveedores podrán abstenerse de
            hacer una distribución a favor del Aliado cuando sospechen que hubo
            fraude, hurto o daño de la mercancía, mientras conduce su
            investigación interna.
          </p>
        </LI>
        {/* F18 */}
        {/* I19 */}
        <LI>
          <b>Vinculación del Aliado y los Proveedores.</b>
          <p>
            El Aliado reconoce y acepta que no es un agente, representante ni
            empleado de ninguno de los Proveedores. Por lo tanto, la aceptación
            de estos términos y condiciones no crea relación de agencia, agencia
            mercantil, sociedad de hecho, ni una relación laboral o sociedad
            entre el Aliado y los Proveedores.
          </p>
          <p>
            Los Proveedores podrán verificar la idoneidad del Aliado para la
            prestación de servicios al Usuario. Esto incluye una verificación
            preliminar de seguridad, incluyendo consultas en bases de datos de
            la fiscalía, procuraduría o cualquier ente de control que los
            Proveedores considere pertinente. Igualmente, esto incluye la
            verificación de documentación del Aliado como lo es la cédula de
            ciudadanía o de extranjería, afiliaciones a seguridad social, entre
            otras.
          </p>
          <p>
            Si bien los Proveedores pueden solicitar al Aliado constancias del
            pago de su seguridad social, el Aliado es el único responsable del
            pago de las mismas. En ninguna circunstancia se entenderá que el
            Aliado es un subordinado o empleado de ninguno de los Proveedores y,
            en consecuencia, en ningún escenario se entenderá que los
            Proveedores serán responsables por el pago al Aliado de prestaciones
            sociales, seguridad social integral, pensiones o lo afiliará al
            sistema de riesgos profesionales.
          </p>
          <p>
            El Aliado deberá mantener indemne a los Proveedores por todas y
            cuales quiera reclamaciones o demandas de carácter laboral o
            relacionadas con el sistema general de seguridad social que puedan
            presentarse en contra de alguno o ambos Proveedores y se obliga a
            reembolsarle de manera inmediata cualquier suma que alguno o ambos
            Proveedores sea obligado a pagar por cualquier autoridad
            administrativa o judicial con base en dichas reclamaciones o
            demandas.
          </p>
          <p>
            Sin perjuicio de lo anterior, los Proveedores podrán facilitar al
            Aliado la compra de ropa u otra clase de artículos que les faciliten
            la prestación de los Servicios a los Usuarios. El Aliado podrá
            libremente decidir si utiliza o no dichas herramientas.
          </p>
        </LI>
        {/* F19 */}
        {/* I20 */}
        <LI>
          <b>Derechos y Obligaciones del Aliado.</b>
          <OL>
            <br />
            <LI>
              <b>
                Los Aliados que decidan tomar Servicios a través de la
                Plataforma tendrán los siguientes derechos:
              </b>
              <OL>
                <br />
                <LI>
                  Ingresar y utilizar la Plataforma para atender los Servicios,
                  y que el Proveedor RAPID FAST S.A.S. garantice el correcto
                  funcionamiento de la Plataforma.
                </LI>
                <br />
                <LI>
                  Que se les respete y pague las tarifas determinadas en la
                  Plataforma, de conformidad con los parámetros y ajustes que se
                  prevean al momento de la contratación de un Servicio.
                </LI>
                <br />
                <LI>
                  Obtener soporte por parte del equipo del Proveedor RAPID FAST
                  S.A.S. para la prestación de los Servicios.
                </LI>
                <br />
                <LI>Recibir las comisiones generadas por referido.</LI>
              </OL>
            </LI>
            <br />
            <LI>
              <b>
                A su vez, los Aliados que presten Servicios a través de la
                Plataforma tendrán las siguientes obligaciones:
              </b>

              <OL>
                <LI>
                  Respetar la propiedad intelectual e industrial de los
                  Proveedores, por lo que el Aliado no tiene derecho alguno a
                  licenciar, vender, revender, asignar, distribuir, anunciar,
                  explotar o sacar provecho comercial o económico alguno de la
                  Plataforma, las marcas, enseñas, lemas comerciales, o
                  herramientas de servicio de los Proveedores.
                </LI>
                <br />
                <LI>
                  No modificar o a hacer trabajos basados en el software, partes
                  del software o la marca de los Proveedores.
                </LI>
                <br />
                <LI>
                  No hacer links o espejos de los Servicios de los Proveedores,
                  o prestar los Servicios de la Plataforma a favor de terceros.
                </LI>
                <br />
                <LI>
                  Abstenerse de hacer “reverse-engineering” (desarmar la
                  aplicación en sus componentes para entender su funcionamiento,
                  así sea con fines académicos y/o no lucrativos).
                </LI>
                <br />
                <LI>
                  Exigir y verificar el cumplimiento de las obligaciones de los
                  Proveedores.
                </LI>
                <br />
              </OL>
            </LI>
            <LI>
              <b>
                Prestar los Servicios de acuerdo con los siguientes términos y
                condiciones:
              </b>
              <OL>
                <br />
                <LI>
                  Si el Aliado está disponible en la Plataforma, puede tomar los
                  Servicios ofertados que le correspondan (mensajería,
                  domicilios, transporte y/o ruteos). En caso de no hacerlo su
                  calificación se podrá ver afectada y los Proveedores podrán
                  convocarlo a una nueva capacitación. Si esto sucede
                  repetidamente, los Proveedores podrán limitar su permanencia y
                  uso de la Plataforma.
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a pagar a los Proveedores por el uso de la
                  App mensualmente sesenta mil pesos COP $60.000.
                </LI>
                <br />
                <LI>
                  El aliado se obliga a contar disponibilidad de COP $150.000 en
                  efectivo en todo momento que se encuentre activo en la
                  Plataforma.
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a tener una presentación personal adecuada
                  (ropa limpia y en buen estado, olor agradable, pelo aseado,
                  manos limpias).
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a contar con todas las herramientas
                  necesarias para prestar los Servicios, tales como, celular,
                  manos libres, maleta y/o caja de domicilios, cargador,
                  Daviplata o Nequi, vehículo en buen estado, impermeable, entre
                  otros. Para efectos de claridad, este listado es meramente
                  enunciativo y no taxativo, por lo que los Servicios de los
                  Usuarios podrán exigir herramientas adicionales.
                </LI>
                <br />
                <LI>
                  El Aliado deberá contar con Registro Único Tributario (RUT),
                  celular, plan de datos, fotocopia de la cédula, certificado de
                  EPS, pasado judicial, cargador o pila de repuesto, y, en caso
                  de que sea requerido por ley para el vehículo que maneje:
                  fotocopia del pase, tarjeta de propiedad del vehículo, SOAT,
                  certificado de revisión técnico-mecánica y/o de gases vigente.
                  En caso de no contar con estas herramientas no estará
                  autorizado para acceder a la Plataforma y tomar Servicios.
                </LI>
                <br />
                <LI>
                  Si al Aliado se le extravían, deterioran o cambia alguno de
                  los documentos nombrados en el punto anterior, deberá
                  reportarlo al área de Vinculaciones del Departamento de
                  Operaciones de los Proveedores, a más tardar dentro de los
                  cinco (5) días calendario siguientes a la ocurrencia del
                  hecho.
                </LI>
                <br />
                <LI>
                  El Aliado debe utilizar el vehículo informado a los
                  Proveedores para prestar los Servicios.
                </LI>
                <br />
                <LI>
                  El Aliado debe ser respetuoso con los demás Aliados y con los
                  Usuarios, y mantener un trato cordial y respetuoso con todas
                  las personas que se relacione.
                </LI>
                <br />
                <LI>
                  El Aliado deberá hacer un mínimo de un (1) Servicio al mes. De
                  no hacerlo, los Proveedores podrá convocarlo a una nueva
                  capacitación para garantizar su conocimiento de la Plataforma
                  y su uso adecuado.
                </LI>
                <br />
                <LI>
                  Una vez el Aliado se visualiza como disponible en la
                  Plataforma, deberá cumplir los tiempos y los estándares de
                  Servicio que aplique a cada servicio.
                </LI>
                <br />
                <LI>
                  El Aliado ante cualquier eventualidad que no permita cumplir
                  con los Servicios en los tiempos establecidos, deberá
                  comunicarse con los Proveedores para notificar el estado del
                  servicio tan pronto como le sea posible. En caso de que la
                  eventualidad se repita tres (3) o más veces, podrá ser
                  limitada su permanencia y/o uso de la Plataforma.
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a presentar documentación en los plazos
                  indicados como parte de su actualización dentro de la
                  prestación de sus Servicios. Igualmente, en caso de que los
                  Proveedores le soliciten documentación adicional, tendrá ocho
                  (8) días hábiles para presentarla a la dirección indicada.
                  Esta documentación incluye, pero no está limitado a documentos
                  sobre aportes de seguridad social, RUT, SOAT,
                  Técnico-mecánica, entre otros.
                </LI>
                <br />
                <LI>
                  En caso de que el Aliado pierda el pase o alguno de los
                  documentos exigidos por la ley para poder conducir el vehículo
                  registrado en la Plataforma, deberá reportarlo a los
                  Proveedores y abstenerse de hacer uso de la Plataforma.
                </LI>
                <br />
                <LI>
                  El Aliado deberá tener el GPS activo mientras esté disponible
                  para tomar Servicios y durante los mismos.
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a realizar Servicio de una manera adecuada
                  y cuidadosa. En caso de daño, deterioro o pérdida de la
                  mercancía objeto del Servicio, será penalizado por los
                  Proveedores y deberá asumir el valor declarado de la
                  mercancía. El Aliado autoriza a los Proveedores a descontar de
                  cualquier saldo a favor que tenga, el valor de la penalización
                  y de la mercancía. Será responsabilidad del Aliado que el
                  producto a entregar se encuentre en las mismas condiciones en
                  las que fue recibido y tomar las evidencias necesarias para
                  que lo anterior sea verificado.
                </LI>
                <br />
                <LI>
                  El Aliado garantiza que está afiliado a la seguridad social
                  integral y en consecuencia exonera de todo tipo de
                  responsabilidad tanto a los Proveedores como a los Usuarios
                  por cualquier daño o pérdida que sufra por no estar afiliado.
                </LI>
                <br />
                <LI>
                  El Aliado sólo podrá revisar la mercancía con la autorización
                  previa de los Proveedores. En caso de sospecha de ser una
                  mercancía ilícita o riesgosa, deberá comunicarlo a los
                  Proveedores para obtener dicha autorización.
                </LI>
                <br />
                <LI>
                  El Aliado no deberá seguir instrucciones por parte del Usuario
                  o cualquier destinatario de un Servicio, si no están
                  estipuladas por medio de la Plataforma, o si no son parte de
                  las instrucciones para entrega de mensajería.
                </LI>
                <br />
                <LI>
                  Si el Aliado toma un servicio de domicilios utilizando una
                  herramienta del Usuario (incluyendo más no limitado a una
                  maleta o datáfono), este deberá retornar al punto de venta y
                  hacer entrega de esta, asumiendo el Usuario el costo del
                  desplazamiento de vuelta. En caso de que el Aliado pierda,
                  dañe o no devuelva las herramientas, el Aliado será
                  responsable por el 100% del valor de las mismas, valor que
                  podrá ser descontado por los Proveedores de cualquier saldo a
                  favor que tenga el Aliado en la Plataforma.
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a guardar reserva de la información,
                  documentos, o cualquier otro dato al que tenga acceso tanto de
                  los Proveedores, del Usuario o del destinatario final del
                  Servicio.
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a contestar su celular de contacto en todo
                  momento mientras se encuentra prestando Servicios a través de
                  la Plataforma.
                </LI>
                <br />
                <LI>
                  Desde el momento en que el Aliado acepta tomar un Servicio, se
                  obliga a no ocuparse realizando otros servicios o actividades
                  personales o de terceros.
                </LI>
                <br />
                <LI>
                  El Aliado deberá contar con las herramientas necesarias y
                  cumplir con los procesos establecidos para realizar retiros y
                  recargas de la Plataforma.
                </LI>
                <br />
                <LI>
                  Cuando el Aliado reciba dinero en efectivo y esto implique
                  volver donde el Usuario si el Servicio no está programado como
                  ida y vuelta, el Aliado no debe aceptar el compromiso.
                </LI>
                <br />
                <LI>
                  El Aliado se obliga a recibir la mercancía en buen estado. En
                  caso contrario, el Aliado no deberá aceptar la mercancía y
                  deberá comunicarlo a los Proveedores. En caso de aceptar la
                  mercancía en otro estado, se hará responsable de la misma.
                </LI>
                <br />
                <LI>
                  El Aliado deberá revisar con el destinatario final del
                  Servicio que la mercancía que se le entrega efectivamente fue
                  la solicitada. En caso de no serlo, deberá comunicarse de
                  inmediato con los Proveedores.
                </LI>
                <br />
                <LI>
                  El Aliado no deberá estar bajo el efecto de sustancias
                  psicoactivas ni alcohólicas durante un Servicio.
                </LI>
                <br />
                <LI>
                  Tomar las evidencias de la plataforma, de acuerdo con la
                  capacitación de uso de la plataforma.
                </LI>
                <br />
                <LI>
                  El Aliado deberá asumir el costo del parqueadero si el
                  Servicio que realiza lo requiere.
                </LI>
                <br />
                <LI>
                  El Aliado acepta que en caso de que el Aliado no cumpla con
                  las condiciones previstas en estos términos y condiciones, o
                  en el evento en que contravenga alguna ley de la República de
                  Colombia, los Proveedores podrán suspender, temporal o de
                  manera permanente, el acceso del Aliado a la Plataforma, sin
                  necesidad de una declaración judicial o de explicación alguna
                  al Aliado.
                </LI>
                <br />
                <LI>
                  El Aliado que decida transportar seres vivos lo hará bajo su
                  propia cuenta y riesgo así lo acepta el Usuario. En ningún
                  caso RAPID FAST SAS, será responsable por el trato que el
                  Aliado le de al ser transportado.
                </LI>
                <br />
                <LI>
                  Los puntos de recolección de Productos (es decir, las tiendas
                  de los clientes de los Proveedores), podrán solicitar que los
                  Aliados exhiban documento de identidad (cédula, carné médico,
                  licencia de conducción, etc.), en dicha tienda, hasta que se
                  finalice el servicio con éxito. Una vez finalizado, el Aliado
                  podrá regresar al punto a recoger su documento de identidad.
                  En caso de que el Aliado no exhiba su documento de identidad,
                  el cliente podrá abstenerse de realizar el servicio con dicho
                  Aliado.
                </LI>
              </OL>
            </LI>
          </OL>
        </LI>
        <br />
        {/* F20 */}
        {/* I21 */}
        <LI>
          <b>Deducciones.</b>
        </LI>
        <p>
          En caso de que la mercancía de los Usuarios objeto del Servicio sufra
          algún daño, deterioro o pérdida, el Aliado deberá responder por el
          valor declarado en la Plataforma. Por lo tanto, el Aliado autoriza a
          los Proveedores a descontar de cualquier saldo a favor que tenga con
          dicho Aliado el valor de la mercancía. En caso de que no exista saldo
          a favor, el Aliado se obliga a pagar a los Proveedores, dentro de los
          ocho (8) días calendario, el valor declarado.
        </p>
        <p>
          Igualmente, el Aliado autoriza a los Proveedores a realizar los
          descuentos y deducciones de cualquier saldo a favor que tenga en la
          Plataforma, por el valor de las herramientas que el Aliado
          voluntariamente decida adquirir, que se relacionen con los Servicios
          prestados a los Usuarios.
        </p>
        {/* F21 */}
        {/* I22 */}
        <LI>
          <b>Auditorías</b>
        </LI>
        <p>
          Los Proveedores tienen el derecho de adelantar auditorías sobre cada
          uno de los servicios realizados por los Aliados, para garantizar que
          se cumplan todas las condiciones de los servicios, incluyendo – más no
          limitado a – evidencias, marcaciones, GPS prendido, tracking, entrega
          y recepción de facturas, devolución de datáfonos, entre otros. Durante
          la auditoría, los Proveedores podrán bloquear temporalmente a los
          Aliados mientras conducen la investigación, y retener cualquier
          dispersión a favor de los Aliados.
        </p>
        <p>
          En caso de que la investigación concluya que alguno o algunos de los
          servicios prestados por los Aliados no cumplieron con la totalidad de
          las condiciones de uso de la Plataforma, los Proveedores podrán
          descontar unilateralmente el valor de los servicios de la cuenta del
          Aliado.
        </p>
        <p>
          Adicionalmente, en caso de que se sospeche que hubo fraude en la
          prestación de servicios, o que se concluya que algún Aliado no está
          siguiendo las instrucciones de uso de la Plataforma, los Proveedores
          podrán bloquear permanentemente al Aliado de la Plataforma.
        </p>
        <p>
          El proceso de auditoría y los descuentos son expresamente aceptados
          por los Aliados con la creación de su usuario en la Plataforma.
        </p>
        {/* F22 */}
        {/* I23 */}
        <LI>
          <b>Política de cancelación</b>
        <OL>
        <br/>
          <LI>
            La política de cancelación de los Proveedores se rige por los
            siguientes términos y condiciones, los cuales podrán ser modificados
            de tiempo en tiempo e incluso directamente en la Plataforma:
          
          <OL>
          <br />
            <LI>
              <b>Servicios en Espera:</b> Todos los servicios que sean
              cancelados por los Proveedores, el Cliente o el Aliado, mientras
              se encuentran en el estado “en espera”, no tendrán ningún cobro al
              Usuario y, por ende, no tendrán ninguna distribución de ingresos a
              favor del Aliado.
            </LI>
            <br />
            <LI>
              <b>Servicios sin cumplimiento:</b> En caso de que el Aliado no
              realice el proceso completo de facturación en tienda, o fuere a
              una tienda diferente a la asignada o, en general incumpliere
              cualquiera de sus obligaciones bajo estos Términos y Condiciones,
              no recibirá la distribución de ingresos por dicho servicio.
            </LI>
            <br />
            <LI>
              <b>Servicios Asignados:</b> Las cancelaciones realizadas desde que
              un servicio fue tomado por un Aliado, y hasta el momento antes de
              que dicho Aliado haya llegado a la segunda parada, no tendrán
              ninguna distribución de ingresos a favor del Aliado.
            </LI>
            <br />
            <LI>
              <b>Servicios en Proceso:</b> La cancelación realizada luego de que
              un Aliado haya llegado a la segunda parada, dará lugar al pago
              completo del servicio a favor del Aliado, siempre y cuando el
              Aliado no incurra en ninguna de las actividades descritas en el
              punto (b) precedente.
            </LI>
          </OL>
          </LI>
          <br />

          <LI>
            Los Proveedores se reservan el derecho de hacer auditorías a los
            servicios prestados para hacer los ajustes necesarios para dar
            cumplimiento a esta Política de Cancelación. Los Aliados aceptan
            dicha auditoría y cualquier ajuste requerido por la misma.
          </LI>
          <OL>

          <br />
          <LI>Política de penalizaciones por demoras al primer punto</LI>
          <br />
          <LI>
            Los Proveedores podrán definir a través de la Plataforma una
            cantidad de minutos que tendrá el Aliado para llegar el primer punto
            de recogida, desde que aceptó el Servicio. Dicho tiempo será
            calculado de manera automática por la Plataforma teniendo en cuenta
            la distancia a la que se encuentra el Aliado y el tiempo promedio de
            desplazamiento. La Plataforma le mostrará al Aliado el conteo
            regresivo para llegar al primer punto. En caso de que el Aliado no
            llegue al primer punto en el tiempo requerido por la Plataforma, el
            Servicio será relanzado a la red y los Proveedores podrán cobrar un
            monto por penalización hasta de COP$1.000. Si esto sucede
            repetidamente, los Proveedores podrán limitar su permanencia y uso
            de la Plataforma.
          </LI>
          </OL>
        </OL>
        </LI>
          {/* F23 */}

      </OL>
    </COntenido>
  );
};

export default Politicas;
